const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJtccWordmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "54 11 105 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M117.04 39.4999C109.224 39.4999 103.4 33.3508 103.4 25.5773V25.5C103.4 17.8039 109.109 11.5 117.194 11.5C122.056 11.5 125.02 13.1587 127.547 15.5405C127.65 15.638 127.658 15.7998 127.565 15.9077L124.884 19.0243C124.785 19.1394 124.611 19.1494 124.498 19.048C122.377 17.1427 120.162 15.9088 117.155 15.9088C112.098 15.9088 108.343 20.1243 108.343 25.4226V25.5C108.343 30.7983 112.06 35.0911 117.194 35.0911C120.359 35.0911 122.475 33.8488 124.702 31.7903C124.81 31.691 124.977 31.6942 125.079 31.7987L127.744 34.523C127.844 34.6248 127.847 34.787 127.749 34.8909C125.067 37.758 121.916 39.4999 117.04 39.4999Z",
    fill: "black",
    fillOpacity: 0.9,
    style: {
      fill: "black",
      fillOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.119 39.4999C136.303 39.4999 130.479 33.3508 130.479 25.5773V25.5C130.479 17.8039 136.188 11.5 144.273 11.5C149.135 11.5 152.099 13.1587 154.626 15.5405C154.729 15.638 154.737 15.7998 154.644 15.9077L151.963 19.0243C151.864 19.1394 151.69 19.1494 151.577 19.048C149.456 17.1427 147.241 15.9088 144.234 15.9088C139.177 15.9088 135.422 20.1243 135.422 25.4226V25.5C135.422 30.7983 139.138 35.0911 144.273 35.0911C147.438 35.0911 149.554 33.8488 151.781 31.7903C151.889 31.691 152.056 31.6942 152.158 31.7987L154.823 34.523C154.923 34.6248 154.925 34.787 154.828 34.8909C152.146 37.758 148.995 39.4999 144.119 39.4999Z",
    fill: "black",
    fillOpacity: 0.9,
    style: {
      fill: "black",
      fillOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3125 39.4999C88.1643 39.4999 88.0442 39.3798 88.0442 39.2316V16.3283C88.0442 16.1801 87.924 16.06 87.7758 16.06H79.4754C79.3272 16.06 79.207 15.9399 79.207 15.7917V11.7683C79.207 11.6201 79.3272 11.5 79.4754 11.5H101.487C101.635 11.5 101.756 11.6201 101.756 11.7683V15.7917C101.756 15.9399 101.635 16.06 101.487 16.06H93.1868C93.0386 16.06 92.9184 16.1801 92.9184 16.3283V39.2316C92.9184 39.3798 92.7983 39.4999 92.6501 39.4999H88.3125Z",
    fill: "black",
    fillOpacity: 0.9,
    style: {
      fill: "black",
      fillOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7527 39.5C59.6341 39.5 56.9671 37.659 55.1343 35.2238C55.0562 35.1201 55.0661 34.9755 55.1558 34.8816L57.9492 31.9575C58.063 31.8385 58.2562 31.8495 58.3585 31.9784C59.8943 33.9143 61.4245 35.0042 63.6746 35.0042C66.2923 35.0042 68.0114 33.3085 68.0114 29.562V11.7684C68.0114 11.6202 68.1315 11.5001 68.2797 11.5001H72.7049C72.8531 11.5001 72.9733 11.6202 72.9733 11.7684V29.7197C72.9733 33.0324 71.9965 35.438 70.3946 37.0549C68.7928 38.6718 66.5267 39.5 63.7527 39.5Z",
    fill: "black",
    fillOpacity: 0.9,
    style: {
      fill: "black",
      fillOpacity: 0.9
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJtccWordmark);
export default __webpack_public_path__ + "static/media/jtcc-wordmark.6078c7ec4e5668df62803e45ab974145.svg";
export { ForwardRef as ReactComponent };